import api from "./api";

export type ServicioEspecializado = {
  Id: number;
  NroPresupuesto: string;
  Contacto?: string | null;
  TipoPresupuesto?: string | null;
  MesCobertura?: string | null;
  UnidadNegocio?: string | null;
  PuntoServicio?: string | null;
  NombreFantasia?: string | null;
  Rubro?: string | null;
  EjecutivoVenta?: string | null;
  Observacion?: string | null;
  FechaInicio?: string | null;
  TotalMetros2?: number | string | null;
  CantHoras?: number | string | null;
  Cuenta?: string | null;
  FechaInsercion?: string | null;
  Estado?: string | null;
  Firma?: string | null;
  Comentario?: string | null;
};

export type ProductoOportunidad = {
  OportunidadCab: number;
  NombreProducto?: string | null;
  Descripcion?: string | null;
  Cantidad?: number | string | null;
};

export type AsignacionServicio = {
  id: number;
  estado: string;
  operario_id: number;
  operario: string;
  legajo: string;
  lun_ent?: string | null;
  lun_sal?: string | null;
  mar_ent?: string | null;
  mar_sal?: string | null;
  mie_ent?: string | null;
  mie_sal?: string | null;
  jue_ent?: string | null;
  jue_sal?: string | null;
  vie_ent?: string | null;
  vie_sal?: string | null;
  sab_ent?: string | null;
  sab_sal?: string | null;
  dom_ent?: string | null;
  dom_sal?: string | null;
  fecha_inicio?: string | null;
  total_horas?: string | null;
};

export type ServicioRealizado = {
  id: number;
  servicio: string;
};

const ServiciosEspecializadosAPI = {
  async listar() {
    const { data } = await api.get("/servicios-especializados");
    return data as { datos: ServicioEspecializado[] };
  },

  async listarProductos() {
    const { data } = await api.get("/servicios-especializados/productos");
    return data as { datos: ProductoOportunidad[] };
  },

  async obtenerDetalle(id: number) {
    const { data } = await api.get(`/servicios-especializados/${id}`);
    return data as { datos: ServicioEspecializado };
  },

  async listarProductosPorId(id: number) {
    const { data } = await api.get(`/servicios-especializados/${id}/productos`);
    return data as { datos: ProductoOportunidad[] };
  },

  async listarAsignaciones(id: number) {
    const { data } = await api.get(
      `/servicios-especializados/${id}/asignaciones`
    );
    return data as { datos: AsignacionServicio[] };
  },

  async crearAsignacion(
    id: number,
    payload: {
      operario: string;
      fecha_inicio: string;
      lun_ent?: string | null;
      lun_sal?: string | null;
      mar_ent?: string | null;
      mar_sal?: string | null;
      mie_ent?: string | null;
      mie_sal?: string | null;
      jue_ent?: string | null;
      jue_sal?: string | null;
      vie_ent?: string | null;
      vie_sal?: string | null;
      sab_ent?: string | null;
      sab_sal?: string | null;
      dom_ent?: string | null;
      dom_sal?: string | null;
    }
  ) {
    const { data } = await api.post(
      `/servicios-especializados/${id}/asignaciones`,
      payload
    );
    return data as { mensaje?: string; error?: string };
  },

  async finalizarServicio(
    id: number,
    payload: { firma_b64: string; comentario?: string; realizados_ids?: number[] }
  ) {
    const { data } = await api.post(
      `/servicios-especializados/${id}/finalizar`,
      payload
    );
    return data as { mensaje?: string; error?: string };
  },

  async listarServiciosRealizados() {
    const { data } = await api.get(`/servicios-especializados/realizados`);
    return data as { datos: ServicioRealizado[] };
  },
};

export default ServiciosEspecializadosAPI;
